import { FC, MouseEvent } from "react";
import { useDispatch } from "../../../hooks";
import { confirmDrawWin } from "../../../redux/draws/confirm-win.handler";
import { DrawCard } from "../../../components/DrawCard/DrawCard";
import { IDraw } from "../DrawItem";

interface IDrawCardConfirmProps {
    draw: IDraw;
}

export const DrawCardConfirm: FC<IDrawCardConfirmProps> = ({ draw }) => {    
    const dispatch = useDispatch();

    const handler = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        
        if (!draw)
            return;

        dispatch(confirmDrawWin(draw.drawId));
    }

    return <DrawCard draw={ draw } handler={ handler } />
};

